// extracted by mini-css-extract-plugin
export default {"container":"DragAndDropField__container___hfCsN","headerContainer":"DragAndDropField__headerContainer___GllG1","leftContainer":"DragAndDropField__leftContainer___oIPU7"};